// import React, { useState, useEffect, useMemo } from "react";
// import {
//   Calendar,
//   Clock,
//   MapPin,
//   Truck,
//   ChevronRight,
//   X,
//   AlertCircle,
//   CheckCircle,
//   Loader,
//   AlertTriangle,
//   RefreshCw,
//   Weight,
//   Eye,
//   Table,
//   Grid,
//   ChevronLeft
// } from "lucide-react";
// import api from "../services/api";

// // ─── helpers ────────────────────────────────────────────────────────────────

// const getServiceNo = () => {
//   try {
//     const raw = localStorage.getItem("persist:root");
//     if (!raw) return null;
//     const root = JSON.parse(raw);
//     const auth = JSON.parse(root.auth);
//     return auth?.userDetails?.ServiceNo || null;
//   } catch {
//     return null;
//   }
// };

// const formatDateTime = (value) => {
//   if (!value) return "-";
//   const date = new Date(value);
//   if (isNaN(date.getTime())) return value;
//   return date.toLocaleString("en-GB", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   });
// };

// const formatTimeOnly = (value) => {
//   if (!value) return "-";
//   const date = new Date(value);
//   if (isNaN(date.getTime())) {
//     const parts = value.split(" ");
//     if (parts[1] && parts[2]) {
//       const [h, m] = parts[1].split(":");
//       let hour = parseInt(h, 10);
//       if (parts[2] === "PM" && hour !== 12) hour += 12;
//       if (parts[2] === "AM" && hour === 12) hour = 0;
//       return `${String(hour).padStart(2, "0")}:${m}`;
//     }
//     return "-";
//   }
//   return date.toLocaleTimeString("en-US", {
//     hour: "numeric",
//     minute: "2-digit",
//     hour12: true,
//   });
// };

// const STATUS_COLORS = {
//   Pending: {
//     badge: "bg-yellow-50 text-yellow-700 border-yellow-200",
//     dot: "bg-yellow-400",
//   },
//   Accepted: {
//     badge: "bg-emerald-50 text-emerald-700 border-emerald-200",
//     dot: "bg-emerald-400",
//   },
//   Rejected: {
//     badge: "bg-red-50 text-red-700 border-red-200",
//     dot: "bg-red-400",
//   },
//   Cancelled: {
//     badge: "bg-gray-50 text-gray-600 border-gray-200",
//     dot: "bg-gray-400",
//   },
// };

// const getColors = (status) =>
//   STATUS_COLORS[status] || {
//     badge: "bg-blue-50 text-blue-700 border-blue-200",
//     dot: "bg-blue-400",
//   };

// // ─── Detail Modal ────────────────────────────────────────────────────────────

// const RequestDetailModal = ({ request, onClose }) => {
//   const colors = getColors(request.status);

//   return (
//     <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
//       <div className="bg-white rounded-xl shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
//         <div className="sticky top-0 bg-white z-10 flex items-center justify-between p-4 border-b border-gray-100">
//           <div className="flex items-center gap-2">
//             <div className="p-1.5 bg-blue-50 rounded-lg">
//               <Truck size={16} className="text-blue-600" />
//             </div>
//             <h2 className="text-base font-semibold text-gray-900">Booking Request</h2>
//           </div>
//           <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-lg transition">
//             <X size={16} className="text-gray-400" />
//           </button>
//         </div>

//         <div className="p-4 space-y-4">
//           <div className="flex items-center gap-2">
//             <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border ${colors.badge}`}>
//               <div className={`w-1.5 h-1.5 rounded-full ${colors.dot}`} />
//               {request.status}
//             </span>
//             {request.booking_priority && (
//               <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-purple-50 text-purple-700 border border-purple-200">
//                 Priority: {request.booking_priority}
//               </span>
//             )}
//           </div>

//           <div className="grid grid-cols-2 gap-3">
//             <div className="bg-gray-50 rounded-lg p-2">
//               <p className="text-[10px] font-medium text-gray-500">Request ID</p>
//               <p className="text-sm font-semibold text-gray-900 font-mono mt-0.5">{request.reqId}</p>
//             </div>
//             {request.bId && request.bId !== "0" && (
//               <div className="bg-gray-50 rounded-lg p-2">
//                 <p className="text-[10px] font-medium text-gray-500">Booking ID</p>
//                 <p className="text-sm font-semibold text-gray-900 font-mono mt-0.5">{request.bId}</p>
//               </div>
//             )}
//             {request.vId && (
//               <div className="bg-gray-50 rounded-lg p-2">
//                 <p className="text-[10px] font-medium text-gray-500">Vehicle</p>
//                 <p className="text-sm font-semibold text-gray-900 font-mono mt-0.5">{request.vId}</p>
//               </div>
//             )}
//             {request.tonnage && (
//               <div className="bg-gray-50 rounded-lg p-2">
//                 <p className="text-[10px] font-medium text-gray-500 flex items-center gap-1">Tonnage</p>
//                 <p className="text-sm font-semibold text-gray-900 mt-0.5">{request.tonnage}</p>
//               </div>
//             )}
//           </div>

//           <div className="bg-blue-50 rounded-lg p-3 border border-blue-100">
//             <h4 className="text-xs font-semibold text-blue-800 mb-2 flex items-center gap-1.5">
//               <Clock size={12} /> Schedule
//             </h4>
//             <div className="space-y-1.5 text-xs">
//               <div className="flex justify-between">
//                 <span className="text-gray-600">Requested on</span>
//                 <span className="font-medium text-gray-900">{formatDateTime(request.bookingDT)}</span>
//               </div>
//               <div className="flex justify-between">
//                 <span className="text-gray-600">Start time</span>
//                 <span className="font-medium text-gray-900">{formatTimeOnly(request.bsTime)}</span>
//               </div>
//               <div className="flex justify-between">
//                 <span className="text-gray-600">End time</span>
//                 <span className="font-medium text-gray-900">{formatTimeOnly(request.beTime)}</span>
//               </div>
//             </div>
//           </div>

//           {(request.From || request.TO) && (
//             <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
//               <h4 className="text-xs font-semibold text-gray-700 mb-2 flex items-center gap-1.5">
//                 <MapPin size={12} /> Route
//               </h4>
//               <div className="space-y-2">
//                 {request.From && (
//                   <div className="flex items-start gap-2">
//                     <div className="w-5 h-5 rounded-full bg-emerald-500 flex-shrink-0 flex items-center justify-center text-white text-[10px] font-bold">A</div>
//                     <div>
//                       <p className="text-[10px] text-gray-500">From</p>
//                       <p className="text-xs font-medium text-gray-900">{request.From}</p>
//                     </div>
//                   </div>
//                 )}
//                 {request.TO && (
//                   <div className="flex items-start gap-2">
//                     <div className="w-5 h-5 rounded-full bg-red-500 flex-shrink-0 flex items-center justify-center text-white text-[10px] font-bold">B</div>
//                     <div>
//                       <p className="text-[10px] text-gray-500">To</p>
//                       <p className="text-xs font-medium text-gray-900">{request.TO}</p>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           {request.Remark && (
//             <div className="bg-gray-50 rounded-lg p-2">
//               <p className="text-[10px] font-medium text-gray-500">Remark</p>
//               <p className="text-xs text-gray-700 mt-0.5">{request.Remark}</p>
//             </div>
//           )}

//           {request.BookingStatus && (
//             <div className="text-center">
//               <span className="text-[10px] bg-blue-50 text-blue-700 px-2 py-1 rounded-full border border-blue-200">
//                 {request.BookingStatus}
//               </span>
//             </div>
//           )}
//         </div>

//         <div className="border-t border-gray-100 p-4">
//           <button onClick={onClose} className="w-full px-3 py-1.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition">
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ─── Mobile Card Component ───────────────────────────────────────────────────

// const RequestCard = ({ request, onClick }) => {
//   const colors = getColors(request.status);

//   return (
//     <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden hover:shadow-md transition">
//       <div className="p-3 border-b border-gray-100">
//         <div className="flex items-center justify-between gap-2">
//           <div>
//             <h3 className="text-sm font-semibold text-gray-900">#{request.reqId}</h3>
//             <p className="text-[10px] text-gray-500 mt-0.5">{formatDateTime(request.bookingDT)}</p>
//           </div>
//           <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[10px] font-medium border ${colors.badge}`}>
//             <div className={`w-1 h-1 rounded-full ${colors.dot}`} />
//             {request.status}
//           </span>
//         </div>
//       </div>

//       <div className="p-3 space-y-2">
//         {(request.From || request.TO) && (
//           <div className="space-y-1.5">
//             {request.From && (
//               <div className="flex items-center gap-2">
//                 <div className="w-4 h-4 rounded-full bg-emerald-500 flex-shrink-0 flex items-center justify-center text-white text-[8px] font-bold">A</div>
//                 <p className="text-xs text-gray-700 truncate flex-1">{request.From}</p>
//               </div>
//             )}
//             {request.TO && (
//               <div className="flex items-center gap-2">
//                 <div className="w-4 h-4 rounded-full bg-red-500 flex-shrink-0 flex items-center justify-center text-white text-[8px] font-bold">B</div>
//                 <p className="text-xs text-gray-700 truncate flex-1">{request.TO}</p>
//               </div>
//             )}
//           </div>
//         )}

//         <div className="flex items-center gap-3 text-xs text-gray-500">
//           {request.bsTime && (
//             <div className="flex items-center gap-1">
//               <Clock size={10} />
//               <span>{formatTimeOnly(request.bsTime)}</span>
//             </div>
//           )}
//           {request.tonnage && (
//             <div className="flex items-center gap-1">
//               <Weight size={10} />
//               <span>{request.tonnage}</span>
//             </div>
//           )}
//         </div>

//         {request.Remark && (
//           <p className="text-[10px] text-gray-500 italic truncate border-t border-gray-100 pt-1">
//             "{request.Remark}"
//           </p>
//         )}
//       </div>

//       <div className="p-2 bg-gray-50 border-t border-gray-100">
//         <button onClick={onClick} className="w-full inline-flex items-center justify-center gap-1 px-2 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition">
//           <Eye size={12} /> View Details
//         </button>
//       </div>
//     </div>
//   );
// };

// // ─── Main Component ──────────────────────────────────────────────────────────

// const BookingRequestList = () => {
//   const [requests, setRequests] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [statusFilter, setStatusFilter] = useState("All");
//   const [selectedRequest, setSelectedRequest] = useState(null);
//   const [viewMode, setViewMode] = useState('table');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10);

//   // Detect screen size for default view
//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth < 768) {
//         setViewMode('card');
//       } else {
//         setViewMode('table');
//       }
//     };
//     handleResize();
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const loadRequests = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const serviceNo = getServiceNo();
//       if (!serviceNo) throw new Error("Service number not found. Please log in again.");

//       const response = await api.get(
//         `https://aeroviewbackend.dockyardsoftware.com/BookingRegister/GetBookingRequestDetails?bid&bdate&reqId&tonnage&bsnno=${serviceNo}`
//       );

//       const data = response?.data?.resultSet;
//       if (Array.isArray(data)) {
//         setRequests(data);
//       } else {
//         setRequests([]);
//       }
//     } catch (err) {
//       setError(err?.response?.data?.message || err?.message || "Failed to load booking requests.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadRequests();
//   }, []);

//   const filteredRequests = useMemo(() => {
//     if (statusFilter === "All") return requests;
//     return requests.filter((r) => r.status === statusFilter);
//   }, [requests, statusFilter]);

//   // Pagination
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentRequests = filteredRequests.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredRequests.length / itemsPerPage);

//   const availableStatuses = useMemo(() => {
//     const set = new Set(requests.map((r) => r.status).filter(Boolean));
//     return ["All", ...Array.from(set)];
//   }, [requests]);

//   const getStatusBadge = (status) => {
//     const colors = getColors(status);
//     return `inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[10px] font-medium border ${colors.badge}`;
//   };

//   return (
//     <div className="space-y-4">
//       {/* Header */}
//       <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-3">
//         <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
//           <div>
//             <h2 className="text-sm font-semibold text-gray-900">Booking Requests</h2>
//             {!loading && !error && (
//               <p className="text-[10px] text-gray-500 mt-0.5">{requests.length} total request{requests.length !== 1 ? "s" : ""}</p>
//             )}
//           </div>
//           <div className="flex items-center gap-2">
//             <button
//               onClick={loadRequests}
//               disabled={loading}
//               className="p-1.5 rounded-lg bg-gray-100 hover:bg-gray-200 transition disabled:opacity-50"
//               title="Refresh"
//             >
//               <RefreshCw size={14} className={loading ? "animate-spin" : ""} />
//             </button>
            
//             {/* View Toggle - Desktop only */}
//             <div className="hidden sm:flex gap-1 bg-gray-100 p-0.5 rounded-lg">
//               <button
//                 onClick={() => setViewMode('table')}
//                 className={`px-2 py-1 text-xs font-medium rounded transition ${
//                   viewMode === 'table' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'
//                 }`}
//               >
//                 <Table size={12} className="inline mr-1" />
//                 Table
//               </button>
//               <button
//                 onClick={() => setViewMode('card')}
//                 className={`px-2 py-1 text-xs font-medium rounded transition ${
//                   viewMode === 'card' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'
//                 }`}
//               >
//                 <Grid size={12} className="inline mr-1" />
//                 Cards
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Filters */}
//       <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-3">
//         <div className="flex flex-wrap gap-1.5">
//           {availableStatuses.map((status) => {
//             const isActive = statusFilter === status;
//             const count = requests.filter((r) => r.status === status).length;
//             return (
//               <button
//                 key={status}
//                 onClick={() => {
//                   setStatusFilter(status);
//                   setCurrentPage(1);
//                 }}
//                 className={`px-2.5 py-1 rounded-lg text-xs font-medium whitespace-nowrap transition ${
//                   isActive ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                 }`}
//               >
//                 {status}
//                 {status !== "All" && <span className="ml-1 text-[10px] opacity-70">({count})</span>}
//               </button>
//             );
//           })}
//         </div>
//       </div>

//       {/* Loading */}
//       {loading && (
//         <div className="flex items-center justify-center py-12">
//           <Loader size={20} className="text-gray-400 animate-spin" />
//           <span className="ml-2 text-xs text-gray-500">Loading booking requests...</span>
//         </div>
//       )}

//       {/* Error */}
//       {error && !loading && (
//         <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-start gap-3">
//           <AlertTriangle size={16} className="text-red-600 flex-shrink-0 mt-0.5" />
//           <div className="flex-1">
//             <p className="text-xs font-medium text-red-800">Failed to load requests</p>
//             <p className="text-xs text-red-700 mt-0.5">{error}</p>
//             <button onClick={loadRequests} className="mt-2 px-2 py-1 bg-red-600 text-white text-xs rounded-lg hover:bg-red-700 transition">
//               Try Again
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Table View - Desktop */}
//       {!loading && !error && viewMode === 'table' && filteredRequests.length > 0 && (
//         <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden">
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead className="bg-gray-50 border-b border-gray-100">
//                 <tr>
//                   <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500">Req ID</th>
//                   <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500">Status</th>
//                   <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500">From → To</th>
//                   <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500">Date & Time</th>
//                   <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500">Tonnage</th>
//                   <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500">Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-50">
//                 {currentRequests.map((req) => {
//                   const colors = getColors(req.status);
//                   return (
//                     <tr key={req.reqId} className="hover:bg-gray-50/50 transition">
//                       <td className="py-2.5 px-3">
//                         <span className="text-sm font-medium text-gray-900">#{req.reqId}</span>
//                       </td>
//                       <td className="py-2.5 px-3">
//                         <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[10px] font-medium border ${colors.badge}`}>
//                           <div className={`w-1 h-1 rounded-full ${colors.dot}`} />
//                           {req.status}
//                         </span>
//                       </td>
//                       <td className="py-2.5 px-3">
//                         <div className="flex items-center gap-1 text-xs text-gray-600">
//                           <MapPin size={10} className="text-gray-400" />
//                           <span className="truncate max-w-[200px]">
//                             {req.From || "—"} → {req.TO || "—"}
//                           </span>
//                         </div>
//                       </td>
//                       <td className="py-2.5 px-3">
//                         <div className="text-xs text-gray-600">
//                           <div>{formatDateTime(req.bookingDT).split(",")[0]}</div>
//                           <div className="text-[10px] text-gray-400">{formatTimeOnly(req.bsTime)} - {formatTimeOnly(req.beTime)}</div>
//                         </div>
//                       </td>
//                       <td className="py-2.5 px-3">
//                         <span className="inline-flex items-center gap-1 px-1.5 py-0.5 text-xs font-medium bg-orange-50 text-orange-700 rounded">
//                           <Weight size={10} />
//                           {req.tonnage}
//                         </span>
//                       </td>
//                       <td className="py-2.5 px-3">
//                         <button
//                           onClick={() => setSelectedRequest(req)}
//                           className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded transition"
//                         >
//                           <Eye size={12} /> View
//                         </button>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>

//           {/* Pagination */}
//           {totalPages > 1 && (
//             <div className="flex items-center justify-between px-3 py-3 border-t border-gray-100">
//               <p className="text-xs text-gray-500">
//                 Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredRequests.length)} of {filteredRequests.length}
//               </p>
//               <div className="flex gap-1">
//                 <button
//                   onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
//                   disabled={currentPage === 1}
//                   className="p-1.5 text-gray-400 hover:text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed transition"
//                 >
//                   <ChevronLeft size={14} />
//                 </button>
//                 <span className="px-2 py-1 text-xs text-gray-600">
//                   Page {currentPage} of {totalPages}
//                 </span>
//                 <button
//                   onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
//                   disabled={currentPage === totalPages}
//                   className="p-1.5 text-gray-400 hover:text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed transition"
//                 >
//                   <ChevronRight size={14} />
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Card View - Mobile */}
//       {!loading && !error && viewMode === 'card' && filteredRequests.length > 0 && (
//         <>
//           <div className="grid grid-cols-1 gap-3">
//             {currentRequests.map((req) => (
//               <RequestCard key={req.reqId} request={req} onClick={() => setSelectedRequest(req)} />
//             ))}
//           </div>
          
//           {/* Pagination */}
//           {totalPages > 1 && (
//             <div className="flex items-center justify-between">
//               <p className="text-xs text-gray-500">
//                 {indexOfFirstItem + 1}-{Math.min(indexOfLastItem, filteredRequests.length)} of {filteredRequests.length}
//               </p>
//               <div className="flex gap-1">
//                 <button
//                   onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
//                   disabled={currentPage === 1}
//                   className="p-1.5 text-gray-400 hover:text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   <ChevronLeft size={14} />
//                 </button>
//                 <span className="px-2 py-1 text-xs text-gray-600">{currentPage}/{totalPages}</span>
//                 <button
//                   onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
//                   disabled={currentPage === totalPages}
//                   className="p-1.5 text-gray-400 hover:text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   <ChevronRight size={14} />
//                 </button>
//               </div>
//             </div>
//           )}
//         </>
//       )}

//       {/* Empty State */}
//       {!loading && !error && filteredRequests.length === 0 && (
//         <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-12 text-center">
//           <Calendar size={32} className="mx-auto text-gray-300 mb-3" />
//           <h3 className="text-sm font-semibold text-gray-900 mb-1">No Requests Found</h3>
//           <p className="text-xs text-gray-500">
//             {statusFilter === "All" ? "No booking requests have been made yet." : `No ${statusFilter.toLowerCase()} requests.`}
//           </p>
//         </div>
//       )}

//       {/* Detail Modal */}
//       {selectedRequest && <RequestDetailModal request={selectedRequest} onClose={() => setSelectedRequest(null)} />}
//     </div>
//   );
// };

// export default BookingRequestList;



import React, { useState, useEffect, useMemo } from "react";
import {
  Calendar,
  Clock,
  MapPin,
  Truck,
  ChevronRight,
  X,
  AlertCircle,
  CheckCircle,
  Loader,
  AlertTriangle,
  RefreshCw,
  Weight,
  Eye,
  Table,
  Grid,
  ChevronLeft
} from "lucide-react";
import api from "../services/api";

// ─── helpers ────────────────────────────────────────────────────────────────

const getServiceNo = () => {
  try {
    const raw = localStorage.getItem("persist:root");
    if (!raw) return null;
    const root = JSON.parse(raw);
    const auth = JSON.parse(root.auth);
    return auth?.userDetails?.ServiceNo || null;
  } catch {
    return null;
  }
};

const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (isNaN(date.getTime())) return value;
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

const formatTimeOnly = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (isNaN(date.getTime())) {
    const parts = value.split(" ");
    if (parts[1] && parts[2]) {
      const [h, m] = parts[1].split(":");
      let hour = parseInt(h, 10);
      if (parts[2] === "PM" && hour !== 12) hour += 12;
      if (parts[2] === "AM" && hour === 12) hour = 0;
      return `${String(hour).padStart(2, "0")}:${m}`;
    }
    return "-";
  }
  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const STATUS_COLORS = {
  Pending: {
    badge: "bg-yellow-50 text-yellow-700 border-yellow-200",
    dot: "bg-yellow-400",
  },
  Accepted: {
    badge: "bg-emerald-50 text-emerald-700 border-emerald-200",
    dot: "bg-emerald-400",
  },
  Rejected: {
    badge: "bg-red-50 text-red-700 border-red-200",
    dot: "bg-red-400",
  },
  Cancelled: {
    badge: "bg-gray-50 text-gray-600 border-gray-200",
    dot: "bg-gray-400",
  },
};

const getColors = (status) =>
  STATUS_COLORS[status] || {
    badge: "bg-blue-50 text-blue-700 border-blue-200",
    dot: "bg-blue-400",
  };

// ─── Detail Modal ────────────────────────────────────────────────────────────

const RequestDetailModal = ({ request, onClose }) => {
  const colors = getColors(request.status);

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white z-10 flex items-center justify-between p-4 border-b border-gray-100">
          <div className="flex items-center gap-2">
            <div className="p-1.5 bg-blue-50 rounded-lg">
              <Truck size={16} className="text-blue-600" />
            </div>
            <h2 className="text-base font-semibold text-gray-900">Booking Request</h2>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-lg transition">
            <X size={16} className="text-gray-400" />
          </button>
        </div>

        <div className="p-4 space-y-4">
          <div className="flex items-center gap-2">
            <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border ${colors.badge}`}>
              <div className={`w-1.5 h-1.5 rounded-full ${colors.dot}`} />
              {request.status}
            </span>
            {request.Priority && (
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-purple-50 text-purple-700 border border-purple-200">
                Priority: {request.Priority}
              </span>
            )}
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="bg-gray-50 rounded-lg p-2">
              <p className="text-[10px] font-medium text-gray-500">Request ID</p>
              <p className="text-sm font-semibold text-gray-900 font-mono mt-0.5">{request.reqId}</p>
            </div>
            {request.bId && request.bId !== "0" && (
              <div className="bg-gray-50 rounded-lg p-2">
                <p className="text-[10px] font-medium text-gray-500">Booking ID</p>
                <p className="text-sm font-semibold text-gray-900 font-mono mt-0.5">{request.bId}</p>
              </div>
            )}
            {request.vId && request.vId !== "" && (
              <div className="bg-gray-50 rounded-lg p-2">
                <p className="text-[10px] font-medium text-gray-500">Vehicle</p>
                <p className="text-sm font-semibold text-gray-900 font-mono mt-0.5">{request.vId}</p>
              </div>
            )}
            {request.tonnage && (
              <div className="bg-gray-50 rounded-lg p-2">
                <p className="text-[10px] font-medium text-gray-500 flex items-center gap-1">Tonnage</p>
                <p className="text-sm font-semibold text-gray-900 mt-0.5">{request.tonnage}</p>
              </div>
            )}
          </div>

          <div className="bg-blue-50 rounded-lg p-3 border border-blue-100">
            <h4 className="text-xs font-semibold text-blue-800 mb-2 flex items-center gap-1.5">
              <Clock size={12} /> Schedule
            </h4>
            <div className="space-y-1.5 text-xs">
              <div className="flex justify-between">
                <span className="text-gray-600">Requested on</span>
                <span className="font-medium text-gray-900">{formatDateTime(request.bookingDT)}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Start time</span>
                <span className="font-medium text-gray-900">{formatTimeOnly(request.bsTime)}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">End time</span>
                <span className="font-medium text-gray-900">{formatTimeOnly(request.beTime)}</span>
              </div>
            </div>
          </div>

          {(request.From || request.TO) && (
            <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
              <h4 className="text-xs font-semibold text-gray-700 mb-2 flex items-center gap-1.5">
                <MapPin size={12} /> Route
              </h4>
              <div className="space-y-2">
                {request.From && (
                  <div className="flex items-start gap-2">
                    <div className="w-5 h-5 rounded-full bg-emerald-500 flex-shrink-0 flex items-center justify-center text-white text-[10px] font-bold">A</div>
                    <div>
                      <p className="text-[10px] text-gray-500">From</p>
                      <p className="text-xs font-medium text-gray-900">{request.From}</p>
                    </div>
                  </div>
                )}
                {request.TO && (
                  <div className="flex items-start gap-2">
                    <div className="w-5 h-5 rounded-full bg-red-500 flex-shrink-0 flex items-center justify-center text-white text-[10px] font-bold">B</div>
                    <div>
                      <p className="text-[10px] text-gray-500">To</p>
                      <p className="text-xs font-medium text-gray-900">{request.TO}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {request.Remark && request.Remark !== "" && (
            <div className="bg-gray-50 rounded-lg p-2">
              <p className="text-[10px] font-medium text-gray-500">Remark</p>
              <p className="text-xs text-gray-700 mt-0.5">{request.Remark}</p>
            </div>
          )}

          {request.BookingStatus && (
            <div className="text-center">
              <span className="text-[10px] bg-blue-50 text-blue-700 px-2 py-1 rounded-full border border-blue-200">
                {request.BookingStatus}
              </span>
            </div>
          )}
        </div>

        <div className="border-t border-gray-100 p-4">
          <button onClick={onClose} className="w-full px-3 py-1.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

// ─── Mobile Card Component ───────────────────────────────────────────────────

const RequestCard = ({ request, onClick }) => {
  const colors = getColors(request.status);

  return (
    <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden hover:shadow-md transition">
      <div className="p-3 border-b border-gray-100">
        <div className="flex items-center justify-between gap-2">
          <div>
            <h3 className="text-sm font-semibold text-gray-900">#{request.reqId}</h3>
            <p className="text-[10px] text-gray-500 mt-0.5">{formatDateTime(request.bookingDT)}</p>
          </div>
          <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[10px] font-medium border ${colors.badge}`}>
            <div className={`w-1 h-1 rounded-full ${colors.dot}`} />
            {request.status}
          </span>
        </div>
      </div>

      <div className="p-3 space-y-2">
        {(request.From || request.TO) && (
          <div className="space-y-1.5">
            {request.From && (
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-emerald-500 flex-shrink-0 flex items-center justify-center text-white text-[8px] font-bold">A</div>
                <p className="text-xs text-gray-700 truncate flex-1">{request.From}</p>
              </div>
            )}
            {request.TO && (
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-red-500 flex-shrink-0 flex items-center justify-center text-white text-[8px] font-bold">B</div>
                <p className="text-xs text-gray-700 truncate flex-1">{request.TO}</p>
              </div>
            )}
          </div>
        )}

        <div className="flex items-center gap-3 text-xs text-gray-500">
          {request.bsTime && (
            <div className="flex items-center gap-1">
              <Clock size={10} />
              <span>{formatTimeOnly(request.bsTime)}</span>
            </div>
          )}
          {request.tonnage && (
            <div className="flex items-center gap-1">
              <Weight size={10} />
              <span>{request.tonnage}</span>
            </div>
          )}
        </div>

        {request.Remark && request.Remark !== "" && (
          <p className="text-[10px] text-gray-500 italic truncate border-t border-gray-100 pt-1">
            "{request.Remark}"
          </p>
        )}
      </div>

      <div className="p-2 bg-gray-50 border-t border-gray-100">
        <button onClick={onClick} className="w-full inline-flex items-center justify-center gap-1 px-2 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition">
          <Eye size={12} /> View Details
        </button>
      </div>
    </div>
  );
};

// ─── Main Component ──────────────────────────────────────────────────────────

const BookingRequestList = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [statusFilter, setStatusFilter] = useState("All");
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [viewMode, setViewMode] = useState('table');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [serviceNo, setServiceNo] = useState(null);

  // Detect screen size for default view
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setViewMode('card');
      } else {
        setViewMode('table');
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const loadRequests = async () => {
    setLoading(true);
    setError(null);
    try {
      const userServiceNo = getServiceNo();
      setServiceNo(userServiceNo);
      
      if (!userServiceNo) {
        throw new Error("Service number not found. Please log in again.");
      }

      console.log("[BookingRequestList] Fetching requests for serviceNo:", userServiceNo);
      
      // Use relative path or get from api service base URL
      const response = await api.get(`/BookingRegister/GetBookingRequestDetails?bsnno=${userServiceNo}`);
      
      console.log("[BookingRequestList] API Response:", response);
      
      const data = response?.data?.resultSet;
      console.log("[BookingRequestList] ResultSet:", data);
      
      if (Array.isArray(data)) {
        // Filter bookings based on bookingSno matching the user's ServiceNo
        const userBookings = data.filter(booking => booking.bookingSno === userServiceNo);
        console.log("[BookingRequestList] Filtered user bookings:", userBookings);
        setRequests(userBookings);
      } else {
        console.log("[BookingRequestList] No resultSet array found");
        setRequests([]);
      }
    } catch (err) {
      console.error("[BookingRequestList] Error loading requests:", err);
      setError(err?.response?.data?.message || err?.message || "Failed to load booking requests.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRequests();
  }, []);

  const filteredRequests = useMemo(() => {
    if (statusFilter === "All") return requests;
    return requests.filter((r) => r.status === statusFilter);
  }, [requests, statusFilter]);

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentRequests = filteredRequests.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredRequests.length / itemsPerPage);

  const availableStatuses = useMemo(() => {
    const set = new Set(requests.map((r) => r.status).filter(Boolean));
    return ["All", ...Array.from(set)];
  }, [requests]);

  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-3">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div>
            <h2 className="text-sm font-semibold text-gray-900">Booking Requests</h2>
            {!loading && !error && serviceNo && (
              <p className="text-[10px] text-gray-500 mt-0.5">
                User: {serviceNo} • {requests.length} booking{requests.length !== 1 ? "s" : ""}
              </p>
            )}
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={loadRequests}
              disabled={loading}
              className="p-1.5 rounded-lg bg-gray-100 hover:bg-gray-200 transition disabled:opacity-50"
              title="Refresh"
            >
              <RefreshCw size={14} className={loading ? "animate-spin" : ""} />
            </button>
            
            {/* View Toggle */}
            <div className="flex gap-1 bg-gray-100 p-0.5 rounded-lg">
              <button
                onClick={() => setViewMode('table')}
                className={`px-2 py-1 text-xs font-medium rounded transition ${
                  viewMode === 'table' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                <Table size={12} className="inline mr-1" />
                Table
              </button>
              <button
                onClick={() => setViewMode('card')}
                className={`px-2 py-1 text-xs font-medium rounded transition ${
                  viewMode === 'card' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                <Grid size={12} className="inline mr-1" />
                Cards
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-3">
        <div className="flex flex-wrap gap-1.5">
          {availableStatuses.map((status) => {
            const isActive = statusFilter === status;
            const count = requests.filter((r) => r.status === status).length;
            return (
              <button
                key={status}
                onClick={() => {
                  setStatusFilter(status);
                  setCurrentPage(1);
                }}
                className={`px-2.5 py-1 rounded-lg text-xs font-medium whitespace-nowrap transition ${
                  isActive ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
              >
                {status}
                {status !== "All" && <span className="ml-1 text-[10px] opacity-70">({count})</span>}
              </button>
            );
          })}
        </div>
      </div>

      {/* Loading */}
      {loading && (
        <div className="flex items-center justify-center py-12">
          <Loader size={20} className="text-gray-400 animate-spin" />
          <span className="ml-2 text-xs text-gray-500">Loading booking requests...</span>
        </div>
      )}

      {/* Error */}
      {error && !loading && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-start gap-3">
          <AlertTriangle size={16} className="text-red-600 flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-xs font-medium text-red-800">Failed to load requests</p>
            <p className="text-xs text-red-700 mt-0.5">{error}</p>
            <button onClick={loadRequests} className="mt-2 px-2 py-1 bg-red-600 text-white text-xs rounded-lg hover:bg-red-700 transition">
              Try Again
            </button>
          </div>
        </div>
      )}

      {/* Table View - Always show when in table mode */}
      {!loading && !error && viewMode === 'table' && (
        <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-100">
                <tr>
                  <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500">Req ID</th>
                  <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500">Status</th>
                  <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500">From → To</th>
                  <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500">Date & Time</th>
                  <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500">Tonnage</th>
                  <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {currentRequests.length > 0 ? (
                  currentRequests.map((req) => {
                    const colors = getColors(req.status);
                    return (
                      <tr key={req.reqId} className="hover:bg-gray-50/50 transition">
                        <td className="py-2.5 px-3">
                          <span className="text-sm font-medium text-gray-900">#{req.reqId}</span>
                        </td>
                        <td className="py-2.5 px-3">
                          <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[10px] font-medium border ${colors.badge}`}>
                            <div className={`w-1 h-1 rounded-full ${colors.dot}`} />
                            {req.status}
                          </span>
                        </td>
                        <td className="py-2.5 px-3">
                          <div className="flex items-center gap-1 text-xs text-gray-600">
                            <MapPin size={10} className="text-gray-400" />
                            <span className="truncate max-w-[200px]">
                              {req.From || "—"} → {req.TO || "—"}
                            </span>
                          </div>
                        </td>
                        <td className="py-2.5 px-3">
                          <div className="text-xs text-gray-600">
                            <div>{formatDateTime(req.bookingDT).split(",")[0]}</div>
                            <div className="text-[10px] text-gray-400">{formatTimeOnly(req.bsTime)} - {formatTimeOnly(req.beTime)}</div>
                          </div>
                        </td>
                        <td className="py-2.5 px-3">
                          <span className="inline-flex items-center gap-1 px-1.5 py-0.5 text-xs font-medium bg-orange-50 text-orange-700 rounded">
                            <Weight size={10} />
                            {req.tonnage}
                          </span>
                        </td>
                        <td className="py-2.5 px-3">
                          <button
                            onClick={() => setSelectedRequest(req)}
                            className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded transition"
                          >
                            <Eye size={12} /> View
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6" className="py-12 text-center">
                      <div className="flex flex-col items-center gap-2">
                        <Calendar size={32} className="text-gray-300" />
                        <p className="text-sm font-medium text-gray-900">No Booking Requests Found</p>
                        <p className="text-xs text-gray-500">
                          {statusFilter === "All" 
                            ? "No booking requests have been created for your account." 
                            : `No ${statusFilter.toLowerCase()} requests found.`}
                        </p>
                        <p className="text-[10px] text-gray-400 mt-1">
                          Create a new booking to see requests here
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex items-center justify-between px-3 py-3 border-t border-gray-100">
              <p className="text-xs text-gray-500">
                Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredRequests.length)} of {filteredRequests.length}
              </p>
              <div className="flex gap-1">
                <button
                  onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                  disabled={currentPage === 1}
                  className="p-1.5 text-gray-400 hover:text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed transition"
                >
                  <ChevronLeft size={14} />
                </button>
                <span className="px-2 py-1 text-xs text-gray-600">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                  disabled={currentPage === totalPages}
                  className="p-1.5 text-gray-400 hover:text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed transition"
                >
                  <ChevronRight size={14} />
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Card View - Always show when in card mode */}
      {!loading && !error && viewMode === 'card' && (
        <>
          <div className="grid grid-cols-1 gap-3">
            {currentRequests.length > 0 ? (
              currentRequests.map((req) => (
                <RequestCard key={req.reqId} request={req} onClick={() => setSelectedRequest(req)} />
              ))
            ) : (
              <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-12 text-center">
                <div className="flex flex-col items-center gap-2">
                  <Calendar size={32} className="text-gray-300" />
                  <p className="text-sm font-medium text-gray-900">No Booking Requests Found</p>
                  <p className="text-xs text-gray-500">
                    {statusFilter === "All" 
                      ? "No booking requests have been created for your account." 
                      : `No ${statusFilter.toLowerCase()} requests found.`}
                  </p>
                  <p className="text-[10px] text-gray-400 mt-1">
                    Create a new booking to see requests here
                  </p>
                </div>
              </div>
            )}
          </div>
          
          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex items-center justify-between">
              <p className="text-xs text-gray-500">
                {indexOfFirstItem + 1}-{Math.min(indexOfLastItem, filteredRequests.length)} of {filteredRequests.length}
              </p>
              <div className="flex gap-1">
                <button
                  onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                  disabled={currentPage === 1}
                  className="p-1.5 text-gray-400 hover:text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <ChevronLeft size={14} />
                </button>
                <span className="px-2 py-1 text-xs text-gray-600">{currentPage}/{totalPages}</span>
                <button
                  onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                  disabled={currentPage === totalPages}
                  className="p-1.5 text-gray-400 hover:text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <ChevronRight size={14} />
                </button>
              </div>
            </div>
          )}
        </>
      )}

      {/* Detail Modal */}
      {selectedRequest && <RequestDetailModal request={selectedRequest} onClose={() => setSelectedRequest(null)} />}
    </div>
  );
};

export default BookingRequestList;